module.exports = __webpack_public_path__ + "static/media/tutorial-step-3-01.64b401c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/tutorial-step-3-01.svg
// module id = 473
// module chunks = 0